module.exports = __webpack_public_path__ + "assets/img/driver-btn-b3f55a3e.png";